"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint max-lines-per-function: 0 */

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var modsClassName_1 = require("../assets/modsClassName");

var isInvalid_1 = require("../channels/isInvalid");

var withStyles_1 = require("../decorators/withStyles");

var mixins_1 = require("../theme/mixins");

var InputGroupCell_1 = require("./InputGroupCell");

var transition = 'border-color 0.3s';

var InputView =
/** @class */
function (_super) {
  __extends(InputView, _super);

  function InputView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isFocused: false,
      isHovered: false
    };
    return _this;
  }

  InputView.prototype.toggleFocus = function (value) {
    var _this = this;

    return function () {
      return _this.setState({
        isFocused: value
      }, function () {
        /* istanbul ignore else */
        if (_this.context.setFocus) {
          _this.context.setFocus(_this.state.isFocused);
        }
      });
    };
  };

  InputView.prototype.toggleHover = function (value) {
    var _this = this;

    return function () {
      return _this.setState({
        isHovered: value
      }, function () {
        /* istanbul ignore else */
        if (_this.context.setHover) {
          _this.context.setHover(_this.state.isHovered);
        }
      });
    };
  };

  InputView.prototype.render = function () {
    var _a;

    var _b = this.props,
        classes = _b.classes,
        children = _b.children,
        dangerouslyApplyFocusStyle = _b.dangerouslyApplyFocusStyle,
        dangerouslyApplyHoverStyle = _b.dangerouslyApplyHoverStyle,
        borders = _b.borders;
    var _c = this.context,
        isFirst = _c.isFirst,
        isLast = _c.isLast;
    var isFocused = this.state.isFocused;
    return react_1.default.createElement("div", {
      className: classnames_1.default(classes.base, modsClassName_1.modsClassName(this.props, 'inline', 'link', 'disabled', 'invalid', 'secondary'), (_a = {}, _a[classes.withoutBorders] = borders === 'withoutBorders', _a[classes.first] = isFirst !== false, _a[classes.last] = isLast !== false, _a[classes.focus] = isFocused || dangerouslyApplyFocusStyle, _a[classes.hover] = dangerouslyApplyHoverStyle, _a)),
      onFocus: this.toggleFocus(true),
      onBlur: this.toggleFocus(false),
      onMouseEnter: this.toggleHover(true),
      onMouseMove: this.toggleHover(true),
      onMouseLeave: this.toggleHover(false)
    }, children);
  };

  InputView.contextTypes = __assign({}, InputGroupCell_1.InputGroupContextTypes);
  InputView.defaultProps = {
    borders: 'normal'
  };
  InputView = __decorate([isInvalid_1.withIsInvalid(isInvalid_1.mapIsInvalidToProps), withStyles_1.withStyles(function (theme) {
    var colorError = theme.colorError,
        colorBorder = theme.colorBorder,
        sizeBorderRadius = theme.sizeBorderRadius,
        colorBgSecondary = theme.colorBgSecondary,
        toneValueBase = theme.toneValueBase;
    return {
      base: __assign(__assign({
        flexGrow: 1,
        position: 'relative'
      }, mixins_1.border(theme)), {
        transition: transition,
        '&$inline:not(:last-of-type)': {
          borderRight: 'none'
        },
        '&:not(:last-of-type)': {
          '&$invalid:not($inline)::after, &:not($inline):not($disabled)::after': {
            display: 'none !important'
          },
          '&$invalid': {
            '&:hover::after, &$hover::after': {
              background: mixins_1.calculateBorderColor(colorError.hover)
            },
            '&$focus::after': {
              background: mixins_1.calculateBorderColor(colorError.active)
            }
          },
          '&:not($disabled)': {
            '&:hover::after, &$hover::after': {
              background: mixins_1.calculateBorderColor(colorBorder.hover)
            },
            '&$focus::after': {
              background: mixins_1.calculateBorderColor(colorBorder.active)
            }
          }
        },
        '&$invalid': {
          borderColor: colorError.normal,
          '&:hover, &$hover': {
            borderColor: mixins_1.calculateBorderColor(colorError.hover),
            transition: transition
          },
          '&$focus': {
            borderColor: mixins_1.calculateBorderColor(colorError.active),
            transition: transition
          }
        },
        '&$secondary': {
          borderColor: colorBgSecondary.normal,
          '&:hover, &$hover, &$focus': {
            borderColor: colorBgSecondary.hover
          }
        },
        '&:not($disabled)': {
          '&:hover, &$hover': {
            borderColor: mixins_1.calculateBorderColor(colorBorder.hover),
            transition: transition
          },
          '&$focus': {
            borderColor: mixins_1.calculateBorderColor(colorBorder.active),
            transition: transition
          }
        },
        fallbacks: [{
          '-ms-flex-positive': '1'
        }, {
          '-webkit-box-flex': '1'
        }, {
          '-webkit-flex-grow': '1'
        }],
        '&:not($first)': {
          borderLeft: 'none'
        },
        '&:not($last)': {
          borderRight: 'none'
        }
      }),
      disabled: {
        opacity: toneValueBase,
        background: colorBgSecondary.normal
      },
      focus: {},
      invalid: {},
      hover: {},
      first: {
        borderTopLeftRadius: sizeBorderRadius,
        borderBottomLeftRadius: sizeBorderRadius
      },
      last: {
        borderTopRightRadius: sizeBorderRadius,
        borderBottomRightRadius: sizeBorderRadius,
        marginRight: 0
      },
      inline: {
        display: 'inline-block',
        flexGrow: 'initial',
        fallbacks: [{
          '-ms-flex-positive': 'initial'
        }, {
          '-ms-flex-positive': '0'
        }, {
          '-webkit-box-flex': 'initial'
        }, {
          '-webkit-flex-grow': 'initial'
        }]
      },
      link: {
        border: 'none'
      },
      secondary: {},
      withoutBorders: {
        border: 'none'
      }
    };
  })], InputView);
  return InputView;
}(react_1.default.Component);

exports.default = InputView;